<template>
  <OnofficeActivation marketplace-integration="SYNCHRONISATION">
    <template v-slot:description>
      {{ $t('crm.on-office-activation-sync.description.0') }}
      <strong>{{ $t('crm.on-office-activation-sync.description.1') }}</strong
      >.
    </template>
    <template v-slot:success>
      <b>{{ $t('crm.on-office-activation-sync.success.title') }}</b
      ><br />
      {{ $t('crm.on-office-activation-sync.success.message') }}
    </template>
  </OnofficeActivation>
</template>

<script>
import OnofficeActivation from './OnofficeActivation.vue'

export default {
  components: { OnofficeActivation },
}
</script>
